import * as React from 'react'

export default () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7" cy="7" r="6.5" stroke="#BEC6D6" />
    <path d="M7 11.375V6.125" stroke="#BEC6D6" strokeWidth="1.5" />
    <path d="M7 4.8125V3.5" stroke="#BEC6D6" strokeWidth="1.5" />
  </svg>
)
